import {
  Stack,
  styled,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useEffect, useState } from "react";
import SkeletonComponent from "../components/Skeleton";
import { requestGetAll } from "../API/request_server";
import Heading from "../components/Heading";

const Container = styled("div")(({ theme }) => ({
  margin: 7,
  [theme.breakpoints.down("sm")]: {
    margin: 10,
  },
}));

export default function Centers() {
  const [_facilitiesData, _setFacilitiesData] = useState([]);
  const [_loader, _setLoader] = useState(false);

  const getData = async () => {
    _setLoader(true);
    const result = await requestGetAll("facilities/getall");
    const data = result.map((item) => ({
      id: item.facility_id,
      facility_title: item.facility_title,
      district_name: item.district_name,
      tehsil_name: item.tehsil_name,
      uc_name: item.uc_name,
      contact_person: item.contact_person,
      contact_no: item.contact_no,
    }));
    _setFacilitiesData(data);
    _setLoader(false);
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <Container>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Heading _title="TB Health Facilities" />
      </Stack>

      {_loader ? (
        <SkeletonComponent />
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>S.#</b>
                </TableCell>
                <TableCell>
                  <b>District</b>
                </TableCell>
                <TableCell>
                  <b>Tehsil</b>
                </TableCell>
                <TableCell>
                  <b>UC</b>
                </TableCell>
                <TableCell>
                  <b>Facility Title</b>
                </TableCell>
                <TableCell>
                  <b>Contact Person</b>
                </TableCell>
                <TableCell>
                  <b>Contact No</b>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {_facilitiesData.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.facility_id}</TableCell>
                  <TableCell>{item.district_name}</TableCell>
                  <TableCell>{item.tehsil_name}</TableCell>
                  <TableCell>{item.uc_name}</TableCell>
                  <TableCell>{item.facility_title}</TableCell>
                  <TableCell>{item.contact_person}</TableCell>
                  <TableCell>{item.contact_no}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
}
